module.exports = __webpack_public_path__ + "img/ic_hotel_blue.0b7e8ceb.svg";